// import SubTitle from '../title/sub-title';
// import Banner from '../banner';
import { Steps } from 'antd';
import PriceFlower from '../../../components/flower/priceFlower';
import bonusCover from '../../../images/bonus-cover.png';
const { Step } = Steps;

const ActivityIntro = () => {
    const month = new Date().getMonth() + 1;
    const date = new Date().getDate();
  const year = new Date().getFullYear();
    return (
        <>
            {/*<Banner />*/}
            <div className='jury__line outlineTitle' style={{ textAlign: 'center', marginTop: '128px' }}>
                <label className={`enter_label  active `}>赛程安排</label>
            </div>
            <div className='home-row schedule_time intro' style={{ marginTop: '64px', paddingLeft: '250px' }}>
                <Steps progressDot direction='vertical'>
                    <Step
                        title='推广和报名阶段'
                        status={`${year >= 2025 && month >= 12 && date >= 15 ? 'finish' : 'wait'}`}
                        className={`${year >= 2025 && month >= 12 && date >= 15 ? 'active' : ''}`}
                        subTitle=''
                        description={
                            <div>
                                {/* <a href='/enter/college' style={{ textDecoration: 'underline' }}>
                                    开启大赛报名系统，
                                </a> */}
                                1.推广。通过大赛官网（黑龙江科技成果和知识产权交易平台网站）、公众号、主流媒体等开展全方位宣传，通过赛事巡讲等活动进行推广，帮助参赛者全面掌握赛事规则及有关注意事项。<br/>
2.报名。发布大赛通知，开启报名系统，通过项目征集、定向邀请和推荐等方式征集以专利组合为核心的创新项目报名参赛。
                            </div>
                        }
                    />
                    <Step
                        title='初赛阶段'
                        status={`${year >= 2025 && month >= 12 && date >= 15 ? 'finish' : 'wait'}`}
                        className={`${year >= 2025 && month >= 12 && date >= 15 ? 'active' : ''}`}
                        subTitle=''
                        description={
                            <div>
                                由大赛执委会组织专业评委对报名项目进行评审，重点评审项目主要专利产品技术先进性、专利产品技术效果、专利产品市场规模，核心专利授权文本质量、保护范围及稳定性，项目中已布局其他相关专利的数量、类型和质量。根据评审得分以及初创组、成长组项目比例等情况，择优选取进入复赛并予以公示，进入复赛项目不少于100个或不低于20%。
                                <br />
                                {/* 报名截止时间：2022年7月15日。 */}
                            </div>
                        }
                    />
                    <Step
                        title='复赛阶段'
                        status={`${year >= 2025 && month >= 12 && date >= 15 ? 'finish' : 'wait'}`}
                        className={`${year >= 2025 && month >= 12 && date >= 15 ? 'active' : ''}`}
                        subTitle=''
                        description={
                            <div>
                                1.项目路演。由参赛主体在现场就本项目技术（设计）方案和产品进行讲解，重点讲解项目的技术先进性、团队素质、市场化运营、经济效益、专利培育布局、社会效益等。<br/>
2.点评打分。由评委与参赛队伍进行互动交流，现场点评并打分。根据评委打分成绩，择优选取30个项目进入决赛并予以公示。<br/>
复赛将邀请投融资机构、产业园区等机构组成的观摩团现场观看项目路演，助力优秀项目的成果转化运用。
                            </div>
                        }
                    />

                    <Step
                        title='项目对接阶段'
                        status={`${year >= 2025 && month >= 12 && date >= 15 ? 'finish' : 'wait'}`}
                        className={`${year >= 2025 && month === 10 ? 'active' : ''}`}
                        subTitle=''
                        description={
                          <div>
                            大赛组织开展一系列对接活动，邀请参赛项目与相关政府部门、产业园区、上下游企业、投融资机构、服务机构等进行精准对接。设立高校、院所、重点地市项目专区，帮助高价值专利匹配运营服务、产业化、资本等优质资源。在对接活动中达成合作意向的优质项目，将进行“一对一”的深度跟踪服务。
                          </div>}
                    />
                    <Step
                        title='决赛阶段'
                        status={`${year >= 2026 && month >= 1 && date >= 15 ? 'finish' : 'wait'}`}
                        className={`${year >= 2026 && month >= 1 && date >= 15 ? 'active' : ''}`}
                        subTitle=''
                        description={
                            <div>1.项目路演。重点包括：通过现场展示和讲解的方式，对项目的技术先进性、商业规模、市场潜力、配套资源支持等进行阐述。<br/>
2.答辩。由评审专家对路演项目中的技术、市场、战略、专利培育与布局等内容进行提问，路演项目的参赛团队进行答辩。<br/>
3.评委打分。由评委对项目进行点评、提出指导建议并进行打分。大赛执委会汇总决赛项目最终得分，确定各参赛项目成绩排名和获奖等次，对评奖结果进行公示。
                            </div>}
                    />
                    <Step
                        title='颁奖总结阶段'
                        status={`${year >= 2026 && month >= 2  ? 'finish' : 'wait'}`}
                        className={`${year >= 2026 && month >= 2 ? 'active' : ''}`}
                        subTitle=''
                        description={
                            <div>举办首届“龙知交”高价值专利运营大赛颁奖总结仪式，同时对专利转化运用专项行动形成的典型经验做法进行宣传推介，邀请国家、省、市相关政府部门领导，行业专家，高校院所、企业代表等参加颁奖仪式。
                            </div>}
                    />
                </Steps>
            </div>

            <div className='jury__line outlineTitle' style={{ textAlign: 'center', marginTop: '128px' }}>
                <label className={`enter_label  active `}>大赛奖励</label>
            </div>
            <div className='home-row reward-row'>
                <p>（一）本届“龙知交”大赛设金奖、银奖、专项奖，共30项</p>
                <div className='reward-col' style={{width: '100%', display: 'flex'}}>
                    <p style={{width: '50%'}}>
                        <span>金奖：</span>
                        <span>10项，奖金1万元/项。</span>
                    </p>
                    <p style={{width: '50%'}}>
                        <span>银奖：</span>
                        <span>20项，奖金5000元/项。</span>
                    </p>
                </div>
                {/* <div className='reward-col'>
                    <p>
                        <span>专利许可转让奖：</span>
                        <span>3项，奖金3000元/项，奖金合计0.9万元。</span>
                    </p>
                    <p>
                        <span>专利作价入股奖：</span>
                        <span>3项，奖金3000元/项，奖金合计0.9万元。</span>
                    </p>
                </div> */}
                <p>（二）本届“龙知交”大赛设最佳组织奖、金牌导师奖。</p>
                {/* <div className='reward-col'>
                    <p>
                        <span>专利运营价值榜：</span>
                        <span>面向入围决赛的20个项目设立该榜单，其中未获得“专利运营标杆奖”的8个项目将以资鼓励。</span>
                    </p>
                    <p>
                        <span>专利运营优秀榜：</span>
                        <span>通过大赛组委会初筛入围的100个项目，进入“上海市专利运营优秀榜”。</span>
                    </p>
                </div> */}

                <div style={{ lineHeight: '30px' }}></div>
            </div>

            <div className='home-row' style={{ marginTop: '64px' }}>
                <div className='glod-row'>
                    <PriceFlower title={'金奖\n（10项）'} type={'gold'} />
                    <PriceFlower title={'银奖\n（20项）'} type={'gold'} />
                    <PriceFlower title={'最佳组织奖\n（1项）'} type={'blue'} />
                    <PriceFlower title={'金牌导师奖\n（1项）'} type={'blue'} />
                </div>
            </div>
            {/* <div className='home-row bonus-row'>
        <div className='bonus-desc'>2万元现金</div>
        <div className='bonus-desc'>5万元现金</div>
        <div className='bonus-desc'>5万元现金</div>
        <div className='bonus-desc'>5000元现金</div>
        <div className='bonus-desc'>5000元现金</div>
      </div> */}
            {/* <div className='home-row bonus-row' style={{ marginTop: '10px' }}>
        <div className='bonus-desc'>
          <span style={{ fontSize: '28px' }}>若干</span>
        </div>
        <div className='bonus-desc'>
          <span style={{ fontSize: '28px' }}>若干</span>
        </div>
        <div className='bonus-desc'>
          <span style={{ fontSize: '28px' }}>12</span>个
        </div>
        <div className='bonus-desc'>
          <span style={{ fontSize: '28px' }}>若干</span>
        </div>
        <div className='bonus-desc'>
          <span style={{ fontSize: '28px' }}>若干</span>
        </div>
      </div> */}
            {/* <div className='home-row' style={{ marginTop: '57px' }}>
        <div className='activity-div-subTitleContainer'>
          <div className='titleContainer-div-separator'></div>
          <Flower title={'专利运营\n价值榜\n20个'} type={'blue'} />
          <Flower title={'专利运营\n优秀榜\n100个'} type={'blue'} />
          <div className='titleContainer-div-separator'></div>
        </div>
      </div> */}

            {/* <div className="home-row bonus-row small"  style={{marginTop: "10px"}}>
            <div className="bonus-desc"></div>
            <div className="bonus-desc">含最后获奖者</div>
            <div className="bonus-desc">含参赛项目相应的运营机构贡献奖</div>
            <div className="bonus-desc"></div>
        </div>
        <div className="home-row bonus-row"  style={{marginTop: "10px"}}>
            <div className="bonus-desc"></div>
            <div className="bonus-desc"><span className="big">100</span>个</div>
            <div className="bonus-desc"><span className="big">10</span>个</div>
            <div className="bonus-desc"></div>
        </div> */}
            {/* <div className='home-row bonus-row' style={{ marginTop: '64px', width: '80%', justifyContent: 'center' }}>
                <div className='privilege'>
                    <span className='mainTitle'>参赛项目及机构代表将：</span>
                    <br />
                    <ol>
                        <li>
                            <a href='http://www.stte.com' target={'_blank'} rel={'noreferrer'}>
                                优先获得上海技术交易所挂牌交易“直通车”服务
                            </a>
                        </li>
                        <li>直通多家投资机构和基金提供的投资对接服务</li>
                        <li>直通多家金融机构提供的知识产权质押融资服务</li>
                        <li>优先获得现场专访机会和“长三角科技路演中心”项目推广机会</li>
                    </ol>
                </div>
                <div className='cover'>
                    <img src={bonusCover} alt={''} />
                </div>
            </div> */}
            <div
                className='home-row bonus-row'
                style={{
                    marginTop: '128px',
                    marginBottom: '128px',
                    justifyContent: 'center',
                }}
            >
                <button
                    type='button'
                    className='blueButton'
                    onClick={() => (window.location.href = '/enter/college')}
                    style={{ width: '216px', height: '64px' }}
                >
                    初创组报名入口
                </button>
                <button
                    type='button'
                    className='blueButton'
                    onClick={() => (window.location.href = '/enter/enterprise')}
                    style={{
                        width: '216px',
                        height: '64px',
                        marginLeft: '60px',
                    }}
                >
                    成长组报名入口
                </button>
            </div>
        </>
    );
};

export default ActivityIntro;
